import Vue from 'vue'
import store from './store'
import router from './router'
import _Cookie from "./lib/cookie";
import { routes } from '@/router';
import { menuList, childList } from "@/lib/menuList";
import { getLoginUrl } from "@/api/userCenter";
import { getIsAccessIndustry } from "@/api/industry";

const whiteList = ['/login', '/register', '/resetpwd', "/user-center", "/join-ok"];
//登录后白名单
const loginWhiteList = ['/pagetip', '/user/account/infoIndex/info', '/404', '/user/account/infoIndex/pwd', "/user-center", "/no-auth", "/join-ok"];

//是否可以访问当前页面
//判断当前路由是否在权限列表中
function hasPermission(list, roleId) {
  // console.log(list,roleId,"roleid-");
  if (!roleId) {
    return true
  }
  let hasRole = false;
  for (let i = 0; i < list.length; i++) {
    let t = roleId.find(x => x == list[i].id);
    if (t) {
      hasRole = true;
      break;
    }
  }
  return hasRole;
}
function getUrl() {
  let host = window.location.origin;
  let data = { host: host }
  getLoginUrl(data).then((res) => {
    localStorage.setItem("LOGIN_URL", res.data.data);
    window.location.href = res.data.data;
  });
}
// 是否接入工业互联网
function getIsAccessIndustryVersion() {
  return getIsAccessIndustry().then((res) => {
    console.log(res, "是否介入了工业互联网--permission");
    if (res.data && res.data.data == true) {
      localStorage.setItem("IS_ACCESS_INDUSTRY", 1);
    } else {
      localStorage.setItem("IS_ACCESS_INDUSTRY", 0);
    }
  });
}

router.beforeEach(async (to, from, next) => {
  // 如果缓存中没有是否介入工业互联网字段则获取
  if(!localStorage.IS_ACCESS_INDUSTRY){
    await getIsAccessIndustryVersion();
  }
  const ACCESS_TOKEN = _Cookie.get('adminauth');
  console.log(to, ACCESS_TOKEN, from, "to--");
  if (ACCESS_TOKEN) {
    if (to.path === '/login' || to.path == "/") {
      getUrl();
    } else {
      //非子账号所有路由都可访问
      if (localStorage.USER_AUTH == "true") {
        let list = JSON.parse(JSON.stringify(menuList));
        if (localStorage.IS_ACCESS_INDUSTRY == 1) {
          list = list.filter(x => x.frontendCode == 'quota'|| x.frontendCode == 'service');
        }
        store.commit("setMenuList", list);
        next();
        return;
      }
      //获取权限
      const hasRoles = store.state.menuList && store.state.menuList.length > 0;
      //获取当前路由的ID
      let roleId = to.meta.id;
      console.log(roleId, hasRoles, "是否有权限列表");
      if (hasRoles) {
        //如果当前页面是登录后白名单直接访问
        if (loginWhiteList.includes(to.path)) { next(); return }
        let list = store.state.permissionList;
        //判断当前路由是否在权限列表中
        let hasRole = hasPermission(list, roleId);
        console.log(hasRole, "是否有权限");
        //当前页面有权限
        if (hasRole) {
          if (JSON.stringify(to.meta) == '{}') {
            next({ path: '/404' })
          }
          next();
        } else {
          //无权限进入404页面
          next({ path: '/404' })
        }
      } else {//刷新无权限，重新获取权限
        try {
          //没有权限重新获取菜单
          const role = await store.dispatch('getRole');
          //如果当前页面是登录后白名单直接访问
          if (loginWhiteList.includes(to.path)) {
            console.log("登录后白名单");
            next();
            return;
          }
          //权限为空
          if (!role) {
            if (to.path != "/no-auth") {
              next({ path: "/no-auth" });
            }
            return;
          }
          // return;
          let list = role.permissionList;
          //判断当前路由是否在权限列表中
          let hasRole = hasPermission(list, roleId);
          console.log(hasRole, "是否有权限");
          //当前页面有权限
          if (hasRole) {
            if (JSON.stringify(to.meta) == '{}') {
              next({ path: '/404' })
            }
            next();
          } else {
            //无权限进入404页面
            //进入前会再次判断权限中是否有此路由，所以需要在权限列表中添加404，账号中心，消息中心的页面（所有账户都可以访问）,
            next({ path: '/404' })
          }
        } catch (error) {
          console.log(error, "获取权限列表出错");
          _Cookie.remove('adminauth');
          getUrl();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {// 在免登录白名单，直接进入
      next()
    } else {
      getUrl();
    }
  }
});

